import React, { Component } from "react";
import classNames from "classnames";
import { MasterTopbar } from "./MasterTopbar";
import { MasterInlineProfile } from "./MasterInlineProfile";
import { MasterFooter } from "./MasterFooter";
import { AppMenu } from "./AppMenu";
import { AppRightPanel } from "./AppRightPanel";
import "primereact/resources/primereact.min.css";
import "fullcalendar/dist/fullcalendar.css";
import "primeicons/primeicons.css";
import { Route } from "react-router-dom";
import { Dashboard } from "./components/Dashboard/Dashboard";
import { PropSets } from "./components/Sets/PropSets";
import { ManageSets } from "./components/Sets/ManageSets";
import { ManageSetsArchive } from "./components/Sets/ManageSetsArchive";
import { ClassesSets } from "./components/Sets/ClassesSets";
import { CreateSets } from "./components/Sets/CreateSets";
import { CreateClass } from "./components/Sets/CreateClass";
import { CalendarClass } from "./components/Sets/CalendarClass";
import { Classes } from "./components/Classes/Classes";
import { Clients } from "./components/Clients/Clients";
import { Employees } from "./components/Employees/Employees";
import { SwapPool } from "./components/SwapPool/SwapPool";
import { Business } from "./components/Business/BusinessSettings";
import { Room } from "./components/Room/Room";
import { ScrollPanel } from "primereact/components/scrollpanel/ScrollPanel";
import "./ripple.js";
import "./Master.css";

class Master extends Component {
  constructor() {
    super();
    this.state = {
      layoutMode: "static",
      profileMode: "inline",
      overlayMenuActive: false,
      staticMenuDesktopInactive: false,
      staticMenuMobileActive: false,
      rotateMenuButton: false,
      topbarMenuActive: false,
      activeTopbarItem: null,
      darkMenu: false,
      rightPanelActive: false,
      menuActive: false
    };

    this.onDocumentClick = this.onDocumentClick.bind(this);
    this.onMenuClick = this.onMenuClick.bind(this);
    this.onMenuButtonClick = this.onMenuButtonClick.bind(this);
    this.onTopbarMenuButtonClick = this.onTopbarMenuButtonClick.bind(this);
    this.onTopbarItemClick = this.onTopbarItemClick.bind(this);
    this.onMenuItemClick = this.onMenuItemClick.bind(this);
    this.onRootMenuItemClick = this.onRootMenuItemClick.bind(this);
    this.onRightPanelButtonClick = this.onRightPanelButtonClick.bind(this);
    this.onRightPanelClick = this.onRightPanelClick.bind(this);
    this.createMenu();
  }

  onMenuClick(event) {
    this.menuClick = true;

    if (!this.isHorizontal()) {
      setTimeout(() => {
        this.layoutMenuScroller.moveBar();
      }, 500);
    }
  }

  onMenuButtonClick(event) {
    this.menuClick = true;
    this.setState({
      rotateMenuButton: !this.state.rotateMenuButton,
      topbarMenuActive: false
    });

    if (this.state.layoutMode === "overlay") {
      this.setState({
        overlayMenuActive: !this.state.overlayMenuActive
      });
    } else {
      if (this.isDesktop())
        this.setState({
          staticMenuDesktopInactive: !this.state.staticMenuDesktopInactive
        });
      else
        this.setState({
          staticMenuMobileActive: !this.state.staticMenuMobileActive
        });
    }

    event.preventDefault();
  }

  onTopbarMenuButtonClick(event) {
    this.topbarItemClick = true;
    this.setState({ topbarMenuActive: !this.state.topbarMenuActive });
    this.hideOverlayMenu();
    event.preventDefault();
  }

  onTopbarItemClick(event) {
    this.topbarItemClick = true;

    if (this.state.activeTopbarItem === event.item)
      this.setState({ activeTopbarItem: null });
    else this.setState({ activeTopbarItem: event.item });

    event.originalEvent.preventDefault();
  }

  onMenuItemClick(event) {
    if (!event.item.items) {
      this.hideOverlayMenu();
    }
    if (!event.item.items && (this.isHorizontal() || this.isSlim())) {
      this.setState({
        menuActive: false
      });
    }
  }

  onRootMenuItemClick(event) {
    this.setState({
      menuActive: !this.state.menuActive
    });

    event.originalEvent.preventDefault();
  }

  onRightPanelButtonClick(event) {
    this.rightPanelClick = true;
    this.setState({
      rightPanelActive: !this.state.rightPanelActive
    });
    event.preventDefault();
  }

  onRightPanelClick(event) {
    this.rightPanelClick = true;
  }

  onDocumentClick(event) {
    if (!this.topbarItemClick) {
      this.setState({
        activeTopbarItem: null,
        topbarMenuActive: false
      });
    }

    if (!this.menuClick) {
      if (this.isHorizontal() || this.isSlim()) {
        this.setState({
          menuActive: false
        });
      }

      this.hideOverlayMenu();
    }

    if (!this.rightPanelClick) {
      this.setState({
        rightPanelActive: false
      });
    }

    this.topbarItemClick = false;
    this.menuClick = false;
    this.rightPanelClick = false;
  }

  hideOverlayMenu() {
    this.setState({
      rotateMenuButton: false,
      overlayMenuActive: false,
      staticMenuMobileActive: false
    });
  }

  isTablet() {
    let width = window.innerWidth;
    return width <= 1024 && width > 640;
  }

  isDesktop() {
    return window.innerWidth > 1024;
  }

  isMobile() {
    return window.innerWidth <= 640;
  }

  isOverlay() {
    return this.state.layoutMode === "overlay";
  }

  isHorizontal() {
    return this.state.layoutMode === "horizontal";
  }

  isSlim() {
    return this.state.layoutMode === "slim";
  }

  changeTheme(theme) {
    this.changeStyleSheetUrl("layout-css", theme, "layout");
    this.changeStyleSheetUrl("theme-css", theme, "theme");
  }

  changeStyleSheetUrl(id, value, prefix) {
    let element = document.getElementById(id);
    let urlTokens = element.getAttribute("href").split("/");
    urlTokens[urlTokens.length - 1] = prefix + "-" + value + ".css";
    let newURL = urlTokens.join("/");
    element.setAttribute("href", newURL);
  }

  createMenu() {
    localStorage.getItem("roleType") !== "10"
      ? (this.menu = [
          {
            label: "Dashboard",
            icon: "dashboard",
            command: () => {
              window.location = "#/";
            }
          },
          {
            label: "Calendar",
            icon: "web_asset",
            command: () => {
              window.location = "#/sets";
            }
          },
          {
            label: "Clients",
            icon: "person_outline",
            command: () => {
              window.location = "#/clients";
            }
          },
          {
            label: "Rooms",
            icon: "business",
            command: () => {
              window.location = "#/rooms";
            }
          }
        ])
      : (this.menu = [
          {
            label: "Dashboard",
            icon: "dashboard",
            command: () => {
              window.location = "#/";
            }
          },
          {
            label: "Calendar",
            icon: "web_asset",
            command: () => {
              window.location = "#/sets";
            }
          },
          {
            label: "Manage Sets",
            icon: "event_note",
            command: () => {
              window.location = "#/managesets";
            }
          },
          {
            label: "Manage Levels",
            icon: "sort",
            command: () => {
              window.location = "#/classes";
            }
          },
          {
            label: "Clients",
            icon: "person_outline",
            command: () => {
              window.location = "#/clients";
            }
          },
          {
            label: "Swap Pool",
            icon: "loop",
            command: () => {
              window.location = "#/swappool";
            }
          },
          {
            label: "Rooms",
            icon: "business",
            command: () => {
              window.location = "#/rooms";
            }
          }
        ]);
  }

  render() {
    let layoutContainerClassName = classNames("layout-container", {
      "menu-layout-static": this.state.layoutMode !== "overlay",
      "menu-layout-overlay": this.state.layoutMode === "overlay",
      "layout-menu-overlay-active": this.state.overlayMenuActive,
      "menu-layout-slim": this.state.layoutMode === "slim",
      "menu-layout-horizontal": this.state.layoutMode === "horizontal",
      "layout-menu-static-inactive": this.state.staticMenuDesktopInactive,
      "layout-menu-static-active": this.state.staticMenuMobileActive
    });
    let menuClassName = classNames("layout-menu", {
      "layout-menu-dark": this.state.darkMenu
    });

    return (
      <div className="layout-wrapper" onClick={this.onDocumentClick}>
        <div
          ref={el => (this.layoutContainer = el)}
          className={layoutContainerClassName}
        >
          <MasterTopbar
            profileMode={this.state.profileMode}
            horizontal={this.props.horizontal}
            topbarMenuActive={this.state.topbarMenuActive}
            activeTopbarItem={this.state.activeTopbarItem}
            onMenuButtonClick={this.onMenuButtonClick}
            onTopbarMenuButtonClick={this.onTopbarMenuButtonClick}
            onTopbarItemClick={this.onTopbarItemClick}
            onRightPanelButtonClick={this.onRightPanelButtonClick}
          />

          <div className={menuClassName} onClick={this.onMenuClick}>
            <ScrollPanel
              ref={el => (this.layoutMenuScroller = el)}
              style={{ height: "100%" }}
            >
              <div className="menu-scroll-content">
                {this.state.profileMode === "inline" &&
                  this.state.layoutMode !== "horizontal" && (
                    <MasterInlineProfile />
                  )}
                <AppMenu
                  model={this.menu}
                  onMenuItemClick={this.onMenuItemClick}
                  onRootMenuItemClick={this.onRootMenuItemClick}
                  layoutMode={this.state.layoutMode}
                  active={this.state.menuActive}
                />
              </div>
            </ScrollPanel>
          </div>

          <div className="layout-main">
            <Route path="/" exact component={Dashboard} />
            <Route path="/sets" component={PropSets} />
            <Route path="/managesets" component={ManageSets} />
            <Route path="/managesetsarchive" component={ManageSetsArchive} />
            <Route path="/classessets" component={ClassesSets} />
            <Route path="/createsets" component={CreateSets} />
            <Route path="/createclasses" component={CreateClass} />
            <Route path="/calendarclass" component={CalendarClass} />
            <Route path="/classes" component={Classes} />
            <Route path="/clients" component={Clients} />
            <Route path="/employees" component={Employees} />
            <Route path="/swappool" component={SwapPool} />
            <Route path="/businesssettings" component={Business} />
            <Route path="/rooms" component={Room} />

            <MasterFooter />
          </div>

          <AppRightPanel
            expanded={this.state.rightPanelActive}
            onContentClick={this.onRightPanelClick}
          />

          <div className="layout-mask" />
        </div>
      </div>
    );
  }
}

export default Master;



// WEBPACK FOOTER //
// ./src/Master.js